import { ResponseTransform } from "utils";
import api from "api";

export const getIndicadores = async (idProject) => {
    let endPoint = `api/project/${idProject}/get-indicators`;
    let responseApi = await api.get(endPoint).then(ResponseTransform);
    return responseApi;
  };
